var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    fill: "none",
    viewBox: "-.00046253 -64 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m502.92 438.93c37.192-37.192-43.208-177.9-179.58-314.27-136.37-136.37-277.08-216.78-314.27-179.58-23.491 23.49 0.013672 88.309 54.817 167.21-31.256 75.418-16.293 165.47 45.025 226.79 61.319 61.32 151.38 76.281 226.79 45.025 78.904 54.804 143.72 78.309 167.21 54.817zm-156.41-337.44c35.573 35.573 77.346 82.254 113.53 130.85 2.5918-13.106 4.1162-26.489 4.1162-40.352 0-114.8-93.199-207.99-207.99-207.99-13.804 0-27.295 1.3467-40.349 3.918 46.622 34.708 92.537 75.42 130.69 113.57z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.1fc3ceccda3d1a341ecfbc21a4c498d4.svg";
export { ForwardRef as ReactComponent };